// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"3120d417","370":"8fd09e83","444":"4568c1e9","862":"8a62cb3f"}[chunkId] + ".chunk.js";
};